import { Fragment, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Collapsible, Text, VStack } from '@library';
import type { ProductBackorder } from '../../queries/useProductBackorders';
import formatBackorders, {
    BackorderMessages,
} from '../../util/formatBackorders';
import styles from './ProductBackorderAccordion.module.scss';

interface ProductBackorderAccordionProps {
    backorders: ProductBackorder[];
}

const ProductBackorderAccordion = ({
    backorders,
}: ProductBackorderAccordionProps) => {
    const productBackorders = formatBackorders(backorders);

    const pendingCount = backorders.reduce(
        (sum, backorder) => sum + backorder.pendingQuantity,
        0
    );
    return (
        <div className={styles.container}>
            <Collapsible
                trigger={
                    <div
                        className={styles.trigger}
                        data-test-class="backorderAccordionTrigger"
                    >
                        <Text primary medium>
                            <FormattedMessage
                                id={BackorderMessages.Backorder}
                                values={{
                                    count: pendingCount,
                                }}
                            />
                        </Text>
                    </div>
                }
                borderType="none"
                triggerSeparator
            >
                <div className={styles.content}>
                    <VStack gap="small">
                        {productBackorders.map((item, idx) => (
                            <Fragment key={idx}>
                                <Text>
                                    <FormattedMessage
                                        id={item.message}
                                        values={item.values}
                                    />
                                </Text>

                                <div className={styles.separator} />
                            </Fragment>
                        ))}
                    </VStack>
                </div>
            </Collapsible>
        </div>
    );
};

export default memo(ProductBackorderAccordion);
